import { Component, ViewChild } from '@angular/core';
import {
  ActionSheetController,
  Events,
  IonicPage,
  NavController,
  NavParams,
  Refresher,
  ViewController
} from 'ionic-angular';
import { TimezoneProvider } from "../../providers/timezone/timezone";
import { HttpClient } from "@angular/common/http";
import { ApiErrorHandlerProvider } from "../../providers/api-error-handler/api-error-handler";
import { TabsServiceProvider } from "../../providers/tabs-service/tabs-service";
import { StaffServiceProvider } from "../../providers/staff-service/staff-service";
import { TeamServiceProvider } from "../../providers/team-service/team-service";
import moment from "moment";
import { interval } from "rxjs/observable/interval";
import { AdvancedBookingsPage } from "../advanced-bookings/advanced-bookings";
import { ProfileLoginPage } from "../profile-login/profile-login";
import { RegisterGuestServiceProvider } from "../../providers/register-guest-service/register-guest-service";
import { BarberBookingNewPage } from '../barber-booking-new/barber-booking-new';

@IonicPage()
@Component({
  selector: 'page-staff-dashboard',
  templateUrl: 'staff-dashboard.html',
})
export class StaffDashboardPage {

  errors: {};
  loading: boolean;
  today: string;
  dayOfWeek: string;
  closingTime: string;
  shop: any;
  staffs: Array<any>;
  barber: any;
  tuid: string;
  teamId: string;
  currencySymbol: string;
  source: any;
  subscribe: any;

  @ViewChild(Refresher) refresher: Refresher;

  constructor(
    public navCtrl: NavController,
    public events: Events,
    public tz: TimezoneProvider,
    private viewCtrl: ViewController,
    private http: HttpClient,
    private actionSheetCtrl: ActionSheetController,
    private apiErrorHandler: ApiErrorHandlerProvider,
    private tabsProvider: TabsServiceProvider,
    private staffProvider: StaffServiceProvider,
    private teamProvider: TeamServiceProvider,
    private tabsService: TabsServiceProvider,
    private registerGuestService: RegisterGuestServiceProvider
  ) {
    this.dayOfWeek = moment(new Date()).format('dddd').toLowerCase();
  }

  ionViewDidLoad() {
    //
  }

  ionViewDidLeave() {
    this.subscribe.unsubscribe();
  }

  ionViewWillEnter() {
    this.tabsService.hide();
    this.tuid = localStorage.getItem('tuid');
    this.teamId = localStorage.getItem('currentTeamId');

    if (this.tuid) {
      this.loading = true;

      this.refreshStaffPanelData().then(() => {
        this.tz.timezone(this.teamId).then((currencySymbol: string) => {
          this.currencySymbol = currencySymbol;
          return this.currencySymbol;
        });
        this.loading = false;
        this.refreshTimer();
      });
    }

    this.setTodayDateTimeString();
  }

  getAllStaffMembersWithBookings(staffMembers) {
    let userDataPromises = [];
    if (this.staffs != null && this.staffs.length > 0) {
      this.staffs.map((user, index) => {
        // userDataPromises.push(this.getStaffMemberWithBookings(user));
        this.getStaffMemberWithBookings(user).then(
          (result: any) => {
            if (typeof (result) != "undefined" && result != null) {
              this.staffs[index].todays_bookings = result.todays_bookings;
              this.staffs[index].upcoming_advanced_bookings = result.upcoming_advanced_bookings;
              this.staffs[index].todays_completed_bookings = result.todays_completed_bookings;
              this.staffs[index].advanced_booking_hours = result.advanced_booking_hours;
            }
          });
      });
    }
    return Promise.all(userDataPromises);
  }

  getStaffMemberWithBookings(staffMember) {
    return new Promise((resolve, reject) => {
      this.staffProvider.getStaffWithBookings(this.teamId, staffMember.id).then((staffMemberWithBookings: any) => {
        resolve(staffMemberWithBookings);
      }).catch(error => {
        reject(error);
      });
    })
  }

  refreshTimer() {
    // Refreshes every 30 seconds
    this.source = interval(60000);
    this.subscribe = this.source
      .subscribe(() => {
        this.setTodayDateTimeString();
        this.refreshStaffPanelData();
      });
  }

  refreshStaffPanelData() {
    return this.getData().then((shop: any) => {
      this.shop = shop;
      this.staffs = this.shop.users;
      this.loading = false;
      return this.getAllStaffMembersWithBookings(this.shop.users);
    }).then(users => {
      // return this.staffs = users;
    }).then(() => {
      return this.setClosingTime(this.shop);
    });
  }

  setTodayDateTimeString() {
    this.today = moment(new Date()).format('dddd Do MMMM hh:mma');
  }

  getData() {
    return new Promise((resolve, reject) => {
      this.teamProvider.getShop(this.teamId).then((shop: any) => {
        resolve(shop);
      }).catch(error => {
        reject(error)
      })
    });
  }

  setClosingTime(shop) {
    return new Promise((resolve) => {
      this.closingTime = shop.hours[`${this.dayOfWeek}_close`];
      this.closingTime = this.closingTime ? moment(this.closingTime, 'HH:mm:ss').format('h:mma') : '';
      resolve(true);
    });
  }

  canBookInAdvance() {
    if (this.shop.allow_advanced_booking && this.shop.settings.num_days_bookings_can_be_made_in_advance > 0) return true;
    return false;
  }

  openAdvancedBookingPage() {
    // this.registerGuestService.register().then(guestUser => {
    //   this.navCtrl.push(AdvancedBookingsPage, {
    //     shop: this.shop,
    //     byStaff: true,
    //     guestUser: guestUser
    //   });
    // }).catch(_ => {

    // });
    this.registerGuestService.register().then(guestUser => {
      this.navCtrl.push(BarberBookingNewPage, {
        shop: this.shop,
        byStaff: true,
        guestUser: guestUser,
        isAdvanceBooking : true
      });
    }).catch(_ => {

    });
  }

  pullToRefresh() {
    this.refreshStaffPanelData().then(() => {
      this.refresher.complete();
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/staff-dashboard/staff-dashboard.ts